function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#yandex-dzen_svg__clip0_143_14386)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.543 19.543c-1.257 1.297-1.349 2.914-1.457 6.457 3.303 0 5.583-.011 6.76-1.154C25.989 23.669 26 21.28 26 18.086c-3.543.114-5.16.2-6.457 1.457zM10 18.086c0 3.194.011 5.583 1.154 6.76C12.331 25.989 14.611 26 17.914 26c-.114-3.543-.2-5.16-1.457-6.457-1.297-1.257-2.914-1.349-6.457-1.457zM17.914 10c-3.297 0-5.583.011-6.76 1.154C10.011 12.331 10 14.72 10 17.914c3.543-.114 5.16-.2 6.457-1.457 1.257-1.297 1.349-2.914 1.457-6.457zm1.629 6.457c-1.257-1.297-1.349-2.914-1.457-6.457 3.303 0 5.583.011 6.76 1.154C25.989 12.331 26 14.72 26 17.914c-3.543-.114-5.16-.2-6.457-1.457",
  fill: "url(#yandex-dzen_svg__paint0_linear_143_14386)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 18.086v-.172c-3.543-.114-5.16-.2-6.457-1.457-1.257-1.297-1.349-2.914-1.457-6.457h-.172c-.114 3.543-.2 5.16-1.457 6.457-1.297 1.257-2.914 1.349-6.457 1.457v.172c3.543.114 5.16.2 6.457 1.457 1.257 1.297 1.349 2.914 1.457 6.457h.172c.114-3.543.2-5.16 1.457-6.457 1.297-1.257 2.914-1.349 6.457-1.457",
  fill: "#fff"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "yandex-dzen_svg__paint0_linear_143_14386",
  x1: 13,
  y1: 10,
  x2: 25.484,
  y2: 12.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "yandex-dzen_svg__clip0_143_14386"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(10 10)",
  d: "M0 0h16v16H0z"
})));

var SvgYandexDzen = function SvgYandexDzen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgYandexDzen;